import { render } from "./VisualisasiFuseki.vue?vue&type=template&id=fb31741a&scoped=true"
import script from "./VisualisasiFuseki.vue?vue&type=script&lang=js"
export * from "./VisualisasiFuseki.vue?vue&type=script&lang=js"

import "./VisualisasiFuseki.vue?vue&type=style&index=0&id=fb31741a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb31741a"]])

export default __exports__